import { usePrefetchFeatureFlags } from "@portal/api/feature-flags";
import { AppLoading } from "@portal/views/shared/AppLoading";
import { ReactNode } from "react";

type PrefetchProviderProps = {
	children: ReactNode;
};

export const AdminPrefetchProvider = ({ children }: PrefetchProviderProps) => {
	const { isLoading: isFeatureFlagsLoading } = usePrefetchFeatureFlags();

	if (!isFeatureFlagsLoading) {
		return children;
	} else {
		return <AppLoading key="3" />;
	}
};
